import './Preview.less';
import { useEffect, useState } from 'react';
import GLBViewer from '@/components/GLBViewer/GLBViewer';
import close from '@/assets/preview/texture-close.png';
import open from '@/assets/preview/texture-open.png';
import { Select, Spin } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { fileExtension } from '@/utils/file';

export default function preivew() {
  // const { search } = useLocation(); // 获取 ? 后面的内容
  // const query = new URLSearchParams(search);
  const [loading, setLoading] = useState(true);

  // const url = decodeURIComponent(query.get('url'));
  const url = sessionStorage.getItem('preview_url');
  const navigate = useNavigate();
  useEffect(() => {}, []);
  const download = () => {
    const a = document.createElement('a');
    a.href = url;
    a.download = 'model.glb';
    a.click();
  };

  const editTexture = async () => {
    // const res = await projectController.create({
    //   body: {
    //     name: '测试',
    //     streams: [
    //       {
    //         type: 2, // StreamTypeEnum
    //         upload: {
    //           uploadId: uploadId,
    //           completedParts: eTags,
    //         },
    //         zIndex: 1,
    //       },
    //     ],
    //     type: 0, // ProjectTypeEnum
    //     mode: 'texture', // ConsumptionMode
    //     tempId: '',
    //   },
    // });
    // console.log('res', res);
    // if (res.code === 0) {
    //   // 创建成功
    //   const { projectId, url } = res.data;
    //   console.log(res);
    //   sessionStorage.setItem('texture_model_url', url);
    //   setUploadLoading(false);
    //   navigate('/texture/' + projectId);
    // }
  };
  console.log('url', url);
  return (
    <div className="preivew">
      <GLBViewer
        onLoadFinish={() => {
          console.log('loadinng');
          setLoading(false);
        }}
        format={url ? fileExtension(url) : ''}
        url={url}
        style={{ width: '100%', height: '100%' }}></GLBViewer>
      {/* <div className="bottom-tabs">
        <img src={close}></img>
        <img src={open}></img>
      </div> */}
      <div className="right-btns">
        {/* <Select className="select" defaultValue={'balance'}>
          <Select.Option value="balance">Balance</Select.Option>
        </Select> */}
        <div className="download-btn" onClick={download}>
          Download model
        </div>
        {/* <div className="edit-btn" onClick={editTexture}>
          Edit Texture
        </div> */}
      </div>
      {loading ? (
        <div className="preivew-spin">
          <Spin
            style={{ backgroundColor: 'rgb(27,27,27)', marginTop: 20 }}
            spinning={loading}></Spin>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
